import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import Box from '@mui/material/Box';
import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { TypeOcr } from './Types';
// need items in this format

export interface ItemProps {
  items: ImageCarouselProps[];
}
interface ImageCarouselProps {
  name: string; // name and affiliation
  quote: string; //put in quotes
}

function Item(props: ImageCarouselProps) {
  return (
    <>
      <Box
        sx={{
          height: { xs: 450, sm: 450, md: 280, lg: 280 },
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
        mt={3}
      >
        <TypeOcr
          sx={{ width: '75%' }}
          fontSize='14pt'
          align='center'
          color='error.main'
        >
          {props.quote}
        </TypeOcr>
        <TypeOcr align='center' fontSize='13px' color='error.main' mt={2}>
          {props.name}
        </TypeOcr>
      </Box>
    </>
  );
}
//black background one for product pages

export default function QuoteCarousel(props: ItemProps) {
  return (
    <Box
      sx={{
        backgroundColor: 'info.main',
        alignItems: 'center',
        height: { xs: 600, sm: 600, md: 375, lg: 375 },
      }}
    >
      <Carousel
        navButtonsAlwaysInvisible={true}
        IndicatorIcon={<HorizontalRuleIcon fontSize='large' sx={{ mt: 5 }} />} // Previous Example
        indicatorIconButtonProps={{
          style: {
            padding: '3px', // 1
            color: 'warning.main', // 3
          },
        }}
        activeIndicatorIconButtonProps={{
          style: {
            backgroundColor: 'error.main', // 2
          },
        }}
        interval={4000}
        animation='slide'
        stopAutoPlayOnHover
      >
        {props.items.map((item: any, i: any) => (
          <Item key={i} {...item} />
        ))}
      </Carousel>
    </Box>
  );
}
